import ratingList, { ratingBgColors } from "./rating"
import { Done, Notifications, NotificationsNone } from "@mui/icons-material"

const prosodies = [
    {
        id: "LOW", name2: "לא מתאימה", name: "ביצוע נמוך", color: "error",
        borderColor: ratingList[4], bg: ratingBgColors[4], 
        icon: NotificationsNone
    },
    {
        id: "MEDIUM", name2: "בינונית", name: "ביצוע בינוני", color: "secondary",
        borderColor: ratingList[2], bg: ratingBgColors[2], 
        icon: NotificationsNone
    },
    {
        id: "HIGH", name2: "מתאימה", name: "ביצוע גבוה", color: "thirdly",
        borderColor: ratingList[1], bg: ratingBgColors[1],
        icon: Done
    }
]

export default prosodies